module.exports = __webpack_public_path__ + "images/181_2048.jpg";